export default "__VITE_ASSET__DI4JGu7q__"